import { correoPlantillaNormalize } from '../Objetos/CorreoPlantillaModel';

export const Models = {
    correoPlantilla: (x) => correoPlantillaNormalize(x),
};
